import { useNavigate } from "react-router-dom";
import logo from '../img/vivosol-logo.webp';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faKey } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import { useSessionData } from "../components/data/SessionData";
import { shouldUseAuth0 } from '../auth/auth0Config';

function DevLogin() {
  const navigate = useNavigate();
  const { loadInitialData } = useSessionData();

  const handleLogin = async () => {
    await loadInitialData({ force: true });
    navigate("/portfolio");
  };

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub - Login";
  }, []);
  
  return (
    <div className="loginBackground">
      <div className="container">
        <div className="login d-flex flex-column justify-content-center col-lg-5 col-sm-8 col-11 m-auto">
          <form className="px-5 py-5 pt-4">
            <img src={logo} className="logo mb-3" alt="Vivosol" />
            <p>Plant Performance Insights Hub</p>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faEnvelope} /></span>
              <input type="text" className="form-control" placeholder="Enter your email address." aria-label="Enter your email address." aria-describedby="basic-addon1" />
            </div>
            <div className="input-group mb-3">
              <span className="input-group-text" id="basic-addon1"><FontAwesomeIcon icon={faKey} /></span>
              <input type="password" className="form-control" placeholder="Enter your password." aria-label="Enter your password." aria-describedby="basic-addon1" />
            </div>
            <button type="button" className="btn btn-primary w-100" onClick={handleLogin}>LOGIN TO DASHBOARD</button>
          </form>
        </div>
      </div>
    </div>
  );
}

function Auth0Login() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub - Login";
  }, []);

  return (
    <div className="loginBackground">
      <div className="container">
        <div className="login d-flex flex-column justify-content-center col-lg-5 col-sm-8 col-11 m-auto">
          <form className="px-5 py-5 pt-4">
            <img src={logo} className="logo mb-3" alt="Vivosol" />
            <p>Plant Performance Insights Hub</p>
            <button type="button" className="btn btn-primary w-100" onClick={() => loginWithRedirect()}>LOGIN TO DASHBOARD</button>
          </form>
        </div>
      </div>
    </div>
  );
}

function Login() {
  if (shouldUseAuth0()) {
    return <Auth0Login />;
  }
  return <DevLogin />;
}

export default Login;
